<template>
  <AccountPanel title="Sprzedaż">
    <OrderLine :chart-data="datacollection" :height="200" />
    <b-form-group>
      <b-form-radio-group id="radios1" v-model="selected" :options="options" name="radioOpenions">
      </b-form-radio-group>
    </b-form-group>
  </AccountPanel>
</template>

<script>

  import { mapState } from 'vuex';
  import AccountPanel from './AccountPanel.vue'
  import OrderLine from './OrderLineChart.js'
  import {BFormGroup} from 'bootstrap-vue/esm/components/form-group/form-group'
  import {BFormRadioGroup} from 'bootstrap-vue/esm/components/form-radio/form-radio-group'
  import moment from 'moment'


  export default {
    components: {AccountPanel, OrderLine, BFormGroup, BFormRadioGroup},
    data () {
      return {
        stats: {},
        selected: 'month',
        options: [
          { text: 'Ostatni tydzień', value: 'week' },
          { text: 'Ostatni miesiąc', value: 'month' },
          { text: 'Ostatni rok', value: 'year' }
        ],


        datacollection: null,
        sums : [
          {month:'Styczeń', value:0},
          {month:'Luty', value:0},
          {month:'Marzec', value:0},
          {month:'Kwiecień', value:0},
          {month:'Maj', value:0},
          {month:'Czerwiec', value:0},
          {month:'Lipiec', value:0},
          {month:'Sierpień', value:0},
          {month:'Wrzesień', value:0},
          {month:'Październik', value:0},
          {month:'Listopad', value:0},
          {month:'Grudzień', value:0},
        ]
      }
    },
    methods: {
      buildLastYear() {
        let today = new Date();
        let date = new Date();
        date.setMonth(date.getMonth() - 11);
        let labels = [];
        let datasets = [{label: 'Ostatni rok', data: []}];
        while(moment(date).format('YYYY-MM') <= moment(today).format('YYYY-MM')) {
          let dateStr = moment(date).format('YYYY-MM');
          labels.push(dateStr);
          let findData = this.stats.years.find(m => m.month == dateStr);
          datasets[0].data.push(findData ? findData.sum : 0);
          date.setMonth(date.getMonth() + 1);
        }
       this.datacollection = {labels: labels, datasets: datasets};
      },


      buildLastMonth() {
        let today = new Date();
        let date = new Date();
        date.setMonth(date.getMonth() - 1);
        date.setDate(date.getDate() + 1);
        let labels = [];
        let datasets = [{label: 'Ostatni miesiąc', data: []}];
        while(moment(date).format('YYYY-MM-DD') <= moment(today).format('YYYY-MM-DD')) {
          let dateStr = moment(date).format('YYYY-MM-DD');
          labels.push(dateStr);
          let findData = this.stats.months.find(m => m.day == dateStr);
          datasets[0].data.push(findData ? findData.sum : 0);
          date.setDate(date.getDate() + 1);
        }
        this.datacollection = {labels: labels, datasets: datasets};
      },

      buildLastWeek() {
        let today = new Date();
        let date = new Date();
        date.setDate(date.getDate() - 6);
        let labels = [];
        let datasets = [{label: 'Ostatni tydzień', data: []}];
        while(moment(date).format('YYYY-MM-DD') <= moment(today).format('YYYY-MM-DD')) {
          let dateStr = moment(date).format('YYYY-MM-DD');
          labels.push(dateStr);
          let findData = this.stats.weeks.find(m => m.day == dateStr);
          datasets[0].data.push(findData ? findData.sum : 0);
          date.setDate(date.getDate() + 1);
        }
        this.datacollection = {labels: labels, datasets: datasets};
      },




    },
    watch: {
      selected: function () {
        if (this.selected == 'year') {
          this.buildLastYear();
        } else if (this.selected == 'month') {
          this.buildLastMonth();
        } else {
          this.buildLastWeek();
        }
      }
    },

    async beforeMount() {
      this.stats = await this.$store.dispatch('order/stats');
      this.buildLastMonth();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/OrdersCharts.vue